export default __webpack_public_path__ + "static/media/846.a2e21b06.png";